/* eslint-disable no-unused-vars */
import { setLoading } from "./loadingReducer";
import { apiFetch } from "../utils/apiClient";
import { getValidAccessToken } from "../Services/oauthService";
export const INDIVIDUAL_PLANS = "INDIVIDUAL_PLANS";
export const SELECTED_PLANS = "SELECTED_PLANS";
export const CHOOSED_PLANS = "CHOOSED_PLANS";
export const COUNTRY = "COUNTRY";
export const OCCUPATION = "OCCUPATION";
export const RELATION = "RELATION";
export const GET_QUOTE = "GET_QUOTE";
export const ADD_POLICY = "ADD_POLICY";

const initialState = {
  individualPlans: [],
  selectedPlan: [],
  choosedPlan: {},
  country: {},
  occupation: {},
  relation: {},
  quote: [],
  policy: {},
};

const source_id = Number(process.env.REACT_APP_SOC_ID || 1);

const IndividualMedicalReducer = (state = initialState, action) => {
  switch (action.type) {
    case INDIVIDUAL_PLANS:
      return {
        ...state,
        individualPlans: action.payload,
      };
    case SELECTED_PLANS:
      return {
        ...state,
        selectedPlan: action.payload,
      };
    case CHOOSED_PLANS:
      return {
        ...state,
        choosedPlan: action.payload,
      };
    case COUNTRY:
      return {
        ...state,
        country: action.payload,
      };
    case OCCUPATION:
      return {
        ...state,
        occupation: action.payload,
      };
    case RELATION:
      return {
        ...state,
        relation: action.payload,
      };
    case GET_QUOTE:
      return {
        ...state,
        quote: action.payload,
      };
    case ADD_POLICY:
      return {
        ...state,
        policy: action.payload,
      };

    default:
      return state;
  }
};

export default IndividualMedicalReducer;

export const individualMedicalPlans = (data) => ({
  type: INDIVIDUAL_PLANS,
  payload: data,
});

export const individualSelectedPlan = (data) => ({
  type: SELECTED_PLANS,
  payload: data,
});

export const individualChoosedPlan = (data) => ({
  type: CHOOSED_PLANS,
  payload: data,
});

export const individualGetCountry = (data) => ({
  type: COUNTRY,
  payload: data,
});

export const individualGetOccupation = (data) => ({
  type: OCCUPATION,
  payload: data,
});

export const individualGetRelation = (data) => ({
  type: RELATION,
  payload: data,
});

export const individualGetQuote = (data) => ({
  type: GET_QUOTE,
  payload: data,
});

export const addPolicyData = (data) => ({
  type: ADD_POLICY,
  payload: data,
});

export const getIndividualPlans = (data) => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/health/get-plan-premiums/individual-medical`,
        {
          method: "POST",
          body: JSON.stringify({ ...data, source_id }),
          headers: { "Content-Type": "application/json" },
        }
      );
      dispatch(individualMedicalPlans(val.data));
      return val;
    } catch (error) {
      console.error("Error in getIndividualPlans:", error);
      throw error;
    }
  };
};

export const getIndividualPlanOptions = () => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/health/get-individual-plan-options`,
        { method: "GET" }
      );
      return val;
    } catch (error) {
      console.error("Error in getIndividualPlanOptions:", error);
      throw error;
    }
  };
};

export const getCountry = () => {
  return async (dispatch) => {
    try {
      const token = await getValidAccessToken();
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/health/countries`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(individualGetCountry(val.data));
      return val;
    } catch (error) {
      console.error("Error in getCountry:", error);
      throw error;
    }
  };
};

export const getOccupation = () => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/get-occupations`,
        { method: "GET" }
      );
      dispatch(individualGetOccupation(val.data));
      return val;
    } catch (error) {
      console.error("Error in getOccupation:", error);
      throw error;
    }
  };
};

export const getRelation = () => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/medical/health/relations`,
        { method: "GET" }
      );
      dispatch(individualGetRelation(val.data));
      return val;
    } catch (error) {
      console.error("Error in getRelation:", error);
      throw error;
    }
  };
};

export const getQuote = (data) => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/health/get-quotation/individual-medical`,
        {
          method: "POST",
          body: JSON.stringify({ ...data, source_id }),
          headers: { "Content-Type": "application/json" },
        }
      );
      dispatch(individualGetQuote(val.data));
      return val;
    } catch (error) {
      console.error("Error in getQuote:", error);
      throw error;
    }
  };
};

export const getHeathQuestions = () => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/health/questions`,
        { method: "GET" }
      );
      return val;
    } catch (error) {
      console.error("Error in getHeathQuestions:", error);
      throw error;
    }
  };
};

export const getHealthPolicy = (data) => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/health/add-policy/individual-medical`,
        {
          method: "POST",
          body: JSON.stringify({ ...data, source_id }),
          headers: { "Content-Type": "application/json" },
        }
      );
      return val;
    } catch (error) {
      console.error("Error in getHealthPolicy:", error);
      throw error;
    }
  };
};

// Add Policy - sends full application payload to backend
export const addPolicy = (data) => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/health/add-policy/individual-medical`,
        {
          method: "POST",
          body: JSON.stringify({ ...data, source_id }),
          headers: { "Content-Type": "application/json" },
        }
      );
      dispatch(addPolicyData(val.data));
      return val;
    } catch (error) {
      console.error("Error in addPolicy:", error);
      throw error;
    }
  };
};

export const uploadDocument = (data, policyNo) => {
  return async (dispatch) => {
    try {
      // data should be a FormData object
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/health/policy-document/${policyNo}`,
        {
          method: "POST",
          body: data,
        }
      );

      return val;
    } catch (error) {
      console.error("Error in uploadDocument:", error);
      throw error;
    }
  };
};

export const uploadDocumentLogs = (data,transId) => {
  return async (dispatch) => {
    try {
      // data should be a FormData object
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/medical/quotes/uploadDocument/${transId}`,
        {
          method: "PUT",
          body: data,
        }
      );

      return val;
    } catch (error) {
      console.error("Error in uploadDocument:", error);
      throw error;
    }
  };
};

export const getQuestionMedical = () => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/health/questions`,
        { method: "GET" }
      );
      dispatch(individualGetCountry(val.data));
      return val;
    } catch (error) {
      console.error("Error in getCountry:", error);
      throw error;
    }
  };
};

export const getQuestionsMedical = () => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/health/questions`,
        { method: "GET" }
      );
      return val;
    } catch (error) {
      console.error("Error in getIndividualPlanOptions:", error);
      throw error;
    }
  };
};

export const getPolicyDocumentsMedical = (policyNo) => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/health/document/download/medical-documents/${policyNo}`,
        { method: "GET" }
      );
      return val;
    } catch (error) {
      console.error("Error in getIndividualPlanOptions:", error);
      throw error;
    }
  };
};

export const getPolicyDocumentsEnglishMedical = (policy) => {
  return async (dispatch) => {
    try {
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/health/document/download/individual-medical/english/${policy}`,
        { method: "GET" }
      );
      return val;
    } catch (error) {
      console.error("Error in getIndividualPlanOptions:", error);
      throw error;
    }
  };
};

export const sendOTPRequest = (data) => {
  return async (dispatch) => {
    try {
      // data should be a FormData object
      const val = await apiFetch(
        dispatch,
        `${process.env.REACT_APP_API_URL}/api/v1/otp/internal-send`,
        {
          method: "POST",
         body: JSON.stringify(data),
          headers: { "Content-Type": "application/json" },
        }
      );

      return val;
    } catch (error) {
      console.error("Error in sendOTP:", error);
      throw error;
    }
  };
};